import httpClient from "./httpClient";

const END_POINT = "/api/roles";
const getAllRoles = () => httpClient.get(END_POINT);
const getAllRolesOperations = () => httpClient.get(END_POINT + '?withOperations=true')
const updateRole = ({ role, operations }) => httpClient.put(END_POINT + '/' + role, { operations: operations })
export { getAllRoles, getAllRolesOperations, updateRole };
